export default __webpack_public_path__ + "static/media/images.84b28225.svg";